import React from "react";
import NavigationBar from "../components/NavigationBar";
import { Outlet } from "react-router-dom";
import ProjectContextProvider from "../contexts/ProjectContextProvider";
import MediaPlayerModal from "../components/modals/MediaPlayerModal";

// layout with upper navigation
function SecondaryLayout() {
  return (
    <ProjectContextProvider>
      <NavigationBar />
      <div style={{ minHeight: "80vh" }}>
        <Outlet />
      </div>
      <MediaPlayerModal />
    </ProjectContextProvider>
  );
}

export default SecondaryLayout;
